import { queryOptions } from '@tanstack/react-query';
import { UrlUnfurlService, type UnfurlUrlResponseDto } from '@inference.engine/api-client/web';

import { inferenceHttp } from '@/lib/api/http-client';

import { URL_UNFURL_QUERY_KEYS } from './query-keys';

/** The backend caches for 30 days, so a refetch within a session can only repeat itself. */
const STALE_TIME_MS = 60 * 60 * 1000;

/**
 * Metadata a publisher declares about one cited page.
 *
 * Carries no `meta.errorMessage`: a citation that cannot be unfurled falls back to the
 * hostname the panel already has, which is not something to interrupt the reader about.
 */
export const urlUnfurlQueryOptions = (url: string | undefined) =>
  queryOptions({
    queryKey: URL_UNFURL_QUERY_KEYS.detail(url ?? ''),
    queryFn: async ({ signal }): Promise<UnfurlUrlResponseDto> => {
      const response = await UrlUnfurlService.unfurl({
        client: inferenceHttp,
        signal,
        query: { url: url ?? '' },
        throwOnError: true,
      });
      return response.data;
    },
    enabled: Boolean(url),
    staleTime: STALE_TIME_MS,
    // A publisher that blocks us will block us again; one retry is enough to cover a blip.
    retry: 1,
  });
